// -- import * as _ from "lodash-es"
import numbro from "numbro"
import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = "SalesTable"

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const fields = {
  default: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      type: "button",
      button: {
        type: "text"
      },
      thStyle: {
        width: "60px"
      }
    },
    {
      key: "ForecastSalesId",
      label: "预测订单编码",
      sortable: true
    },
    {
      key: "dataAreaId",
      label: "销售公司",
      sortable: true
    },
    {
      key: "CompanyName",
      label: "销售公司名称",
      sortable: true,
      thStyle: { width: "8rem" },
      width: "8rem",
      type: "short"
    },
    {
      key: "CustAccountId",
      label: "客户帐户",
      sortable: true
    },
    {
      key: "CustAccountName",
      label: "客户名称",
      sortable: true,
      thStyle: {
        width: "15rem"
      }
    },
    {
      key: "TEC_FinalCustAccount",
      label: "最终客户",
      sortable: true
    },
    {
      key: "TEC_FinalCustAccount_Name",
      label: "最终客户名称",
      sortable: true,
      thStyle: {
        width: "15rem"
      }
    },

    {
      key: "description",
      label: "备注",
      sortable: true
    },
    {
      key: "create_by",
      label: "创建人",
      sortable: true,
      formatter: (value, key, item) => {
        return item.create_by_username
      }
    },
    {
      key: "create_at",
      label: "创建时间",
      sortable: true,
      type: "datetime"
    },
    {
      key: "update_by",
      label: "修改人",
      sortable: true,
      formatter: (value, key, item) => {
        return item.update_by_username
      }
    },
    {
      key: "update_at",
      label: "修改时间",
      sortable: true,
      type: "datetime"
    },
    {
      key: "fcCheckIsOrderForecastAllDispatched(t.id)",
      label: "状态",
      thStyle: {
        display: "none"
      },
      tdClass: "no-shown-RetailVariantId"
    }
  ],
  item_fields: [
    {
      key: "seq",
      label: "行号",
      sortable: true,
      thStyle: {
        width: "60px"
      }
    },
    {
      key: "ForecastSalesId",
      label: "预测订单编码",
      sortable: true
    },
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      type: "short",
      width: "10rem"
    },
    {
      key: "VariantName",
      label: "变型名称",
      sortable: true,
      type: "short",
      thStyle: {
        width: "8rem"
      }
    },
    {
      key: "ModelId",
      label: "预测模型"
    },
    {
      key: "SEI_ForecastSalesType",
      label: "预测类型"
    },
    {
      key: "SalesQty",
      label: "数量",
      sortable: true,
      type: "integer",
      _precise: 6
    },
    {
      key: "valid_remain",
      label: "剩余派发数量",
      sortable: true,
      type: "integer",
      _precise: 2
    },
    {
      key: "valid_approve",
      label: "待审批数量",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "StartDate",
      label: "装运日期",
      sortable: true,
      type: "date"
    },
    {
      key: "SalesUnitId",
      label: "单位",
      sortable: true
    },
    {
      key: "RetailVariantId",
      label: "变形编号",
      sortable: true,
      width: "8rem",
      thStyle: {
        display: "none"
      },
      tdClass: "no-shown-RetailVariantId"
    },

    {
      key: "is_invent_ready",
      label: "备料",
      sortable: true,
      type: "boolean"
    },
    {
      key: "SEI_CP_ReplenishmentCommit",
      label: "补货计划",
      sortable: true
    },
    {
      key: "WeekName",
      label: "周的名称",
      sortable: true
    },
    {
      key: "description",
      label: "备注",
      sortable: true,
      type: "textarea"
    },
    {
      key: "is_cancel",
      label: "取消",
      type: "boolean"
    }
  ],

  orderForecast_Detail_fileds: [
    {
      key: "AccountNum",
      label: "供应商编号",
      sortable: true,
      editable: true,
      width: "80px"
    },
    {
      key: "SEI_Name",
      label: "供应商名称",
      sortable: true,
      type: "short",
      width: "10rem"
    },
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      type: "short",
      width: "10rem"
    },
    {
      key: "VariantName",
      label: "变型名称",
      sortable: true,
      type: "short",
      thStyle: {
        width: "10rem"
      },
      width: "8rem"
    },
    {
      key: "ModelId",
      label: "预测模型",
      editable: true
    },
    {
      key: "SEI_ForecastSalesType",
      label: "预测类型",
      editable: true,
      type: "textarea"
    },
    {
      key: "qty",
      label: "数量",
      editable: true,
      type: "just_number"
    },
    {
      key: "invent_sum",
      label: "现有库存量",
      type: "number",
      _precise: 6
    },
    {
      key: "delivery_date",
      label: "装运日期",
      editable: true,
      type: "date"
    },
    {
      key: "Capacity",
      label: "产能(天)",
      editable: true,
      type: "just_number"
    },
    {
      key: "SEI_CP_ReplenishmentCommit",
      label: "补货计划",
      sortable: true
    },
    {
      key: "WeekName",
      label: "周的名称",
      sortable: true
    },
    {
      key: "TotalScore",
      label: "评价",
      sortable: true,
      type: "rate",
      disabled: true,
      thStyle: {
        width: "10rem"
      },
      width: "10rem"
    }

  ],
  vend_quote_fileds: [
    {
      key: "AccountNum",
      label: "供应商编号",
      sortable: true,
      width: "80px"
    },
    {
      key: "SEI_Name",
      label: "供应商名称",
      sortable: true,
      type: "short",
      width: "10rem"
    },

    {
      key: "VariantName",
      label: "变型名称",
      sortable: true,
      type: "short",
      thStyle: {
        width: "10rem"
      },
      width: "8rem"
    },
    {
      key: "ModelId",
      label: "预测模型",
      editable: true
    },
    {
      key: "SEI_ForecastSalesType",
      label: "预测类型",
      editable: true,
      type: "textarea"
    },
    {
      key: "qty",
      label: "数量",
      editable: true,
      type: "just_number"
    },
    {
      key: "invent_sum",
      label: "现有库存量",
      type: "number",
      _precise: 6
    },
    {
      key: "delivery_date",
      label: "装运日期",
      editable: true,
      type: "date"
    },
    {
      key: "Capacity",
      label: "产能(天)",
      editable: true,
      type: "just_number"
    },
    {
      key: "TotalScore",
      label: "评价",
      sortable: true,
      type: "rate",
      disabled: true,
      thStyle: {
        width: "10rem"
      },
      width: "10rem"
    }
  ]
}

const dataForm = {
  id: "",
  OrderForecast_Line_id: "", //预测订单明细
  ForecastSalesId: "", ///预测订单编号
  ItemId: "",
  NameAlias: "",
  dataAreaId: "",
  AccountNum: "",
  SEI_Name: "",
  RetailVariantId: "", //变形编号
  VariantName: "", //变型名称
  ModelId: "", //预测模型
  SEI_ForecastSalesType: "", //预测模型
  price: 0,
  qty: 0,
  seq: 0,
  Capacity: 0,
  delivery_date: "",
  TotalScore: 0, ///供应商评价
  description: "",
  AXId: "",
  AXSalesId: "",
  AXInventTransId: "",
  AXPurchId: "",
  AXPurchInventTransId: "",
  SEI_CP_ReplenishmentCommit: "",
  WeekName: ""
}

///前端验证
const rules = {}

const descriptor = {}
const methods = {
  Capacity(val) {
    return numbro(val).format({
      thousandSeparated: true,
      mantissa: 2
    })
  },
  async getItemData(_params) {
    const line_biz_data = new biz_data_helper.base_entity_helper(
      "get_orderforecast_line",
      {},
      {}
    )
    let _fields = _.map(fields.item_fields, "key")
    _fields.push("id")
    _fields.push("ForecastSalesId")
    _fields.push("order_forecast_id")
    let result = await line_biz_data
      .execAction({
        params: _params,
        fields: _fields
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  //保存数据至派单表,修改订单列表明细上的数量
  async saveDispatch(data, update_soline_form_list) {
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "sPlant_OrderForecast_Dispatch",
      create,
      descriptor
    )

    // let check_biz_data = new biz_data_helper.base_entity_helper(
    //   "check_isExiste_vend_item",
    //   {},
    //   {}
    // );

    let so_approve_biz_data = new biz_data_helper.base_entity_helper(
      "sp_updateApproveStatus",
      {},
      {}
    )
    let _actions = []
    ///检查是否预测订单还是已审核状态
    let check_sf_approved_biz_data = new biz_data_helper.base_entity_helper(
      "sPlant_OrderForecast",
      {},
      {}
    )
    ///后端剩余派单数量验证
    let if_can_modify_biz_data = new biz_data_helper.base_entity_helper(
      "CheckIfCanModifySalesForcastDispatch",
      {},
      {}
    )
    ///修改剩余派单数量
    let update_soline_biz_data = new biz_data_helper.base_entity_helper(
      "update_sfl_validremain",
      {},
      {}
    )
    let _fields = ["id"]
    _fields.push("fcCheckSFApproved(t.id)")
    _actions.push(
      check_sf_approved_biz_data
        .selectAction({
          params: [],
          fields: _fields
        })
        .action({
          output_last_item_map: {
            fcCheckSFApproved: "is_sf_approved"
          }
        })
    )
    for (var i in data) {
      // let _companyid = data[i].DataArea;
      // _actions.push(
      //   check_biz_data
      //     .execAction({
      //       params: {
      //         dataAreaId: _companyid,
      //         ItemId: data[i].ItemId
      //       },
      //       fields: ["is_check_ok"]
      //     })
      //     .action({
      //       output_last_item_map: {
      //         is_check_ok: "is_check_ok"
      //       },
      //       rollback_when: {
      //         is_sf_approved: {
      //           "=": false
      //         }
      //       }
      //     })
      // );
      let _documentCreateByUsername = data[i].documentCreateByUsername
      delete data[i].id
      delete data[i].DataArea
      delete data[i].documentCreateByUsername
      let _fields = _.map(fields.orderForecast_Detail_fileds, "key")
      _fields.push("id")
      ///检查是否能派发
      _actions.push(
        if_can_modify_biz_data
          .execAction({
            params: {
              SalesForcastLineId: data[i].OrderForecast_Line_id,
              CurrentDispathId: 0,
              action: "create",
              inputQty: data[i].qty
            },
            fields: ["allowed"]
          })
          .action({
            output_last_item_map: {
              allowed: "allowed"
            },
            rollback_when: {
              // is_check_ok: {
              //   "=": 1
              // }
              is_sf_approved: {
                "=": false
              }
            }
          })
      )
      _actions.push(
        item_biz_data
          .insertAction({
            params: data[i],
            fields: _fields
          })
          .action({
            output_last_item_map: {
              id: "itemId"
            },
            rollback_when: {
              allowed: {
                "=": false
              }
            }
          })
      )

      ///审批
      let credit_form = {
        itemId: "",
        documentType: "SalesForcastDispatch",
        approveType: "", //审批类型："" ---普通审批
        documentCreateByUsername: _documentCreateByUsername,
        salesOrderAmountCNY: 0
      }
      _actions.push(
        so_approve_biz_data
          .execAction({
            params: credit_form,
            fields: ["id"]
          })
          .action({
            mixin_last_item_map: {
              itemId: "itemId"
            }
          })
      )
    }
    if (update_soline_form_list && update_soline_form_list.length > 0) {
      _.each(update_soline_form_list, t => {
        _actions.push(
          update_soline_biz_data
            .execAction({
              params: {
                SForecastLineId: t.id
              },
              fields: ["valid_remain", "valid_approve"]
            })
            .action({})
        )
      })
    }

    let result = await api.query_batch({
      actions: _actions
    })

    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  },

  ///获取所有供应商评价
  async getAllVendAssess(venders) {
    let assess_biz_data = new biz_data_helper.base_entity_helper(
      "sPlant_Rate",
      {},
      {}
    )
    let _fields = ["id", "VendAccountNum", "TotalScore"]
    let result = await assess_biz_data
      .selectAction({
        params: {
          is_deleted: {
            "=": 0
          },
          VendAccountNum: {
            "[]": venders
          }
        },
        fields: _fields
      })
      .run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },

  async getDisDataStateAndInfo(_params) {
    let _actions = []
    const capacity_biz_data = new biz_data_helper.base_entity_helper(
      "get_vend_production_capacity",
      {},
      {}
    )
    let check_biz_data = new biz_data_helper.base_entity_helper(
      "check_isExiste_vend_item",
      {},
      {}
    )
    ///现有库存量
    let get_invent_sum_biz_data = new biz_data_helper.base_entity_helper(
      "get_vend_invent_sum",
      {},
      {}
    )
    _actions.push(
      capacity_biz_data
        .execAction({
          params: _params.get_pc,
          fields: ["ProductionCapacity "]
        })
        .action({})
    )

    _actions.push(
      check_biz_data
        .execAction({
          params: _params.check_vend_has_invent,
          fields: ["is_check_ok"]
        })
        .action({})
    )
    _actions.push(
      get_invent_sum_biz_data
        .execAction({
          params: _params.invent_sum_params
        })
        .action({})
    )

    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  }
}
const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)
export { biz_data, dataForm, fields, methods, rules };

